import React, { useEffect, useState } from "react";
import {
    Button,
    Row,
    Col,
    Modal,
    Table,
    Space,
    Tag,
    Card,
    Typography,
    Empty,
    Tooltip,
    Popconfirm
} from "antd";
import {
    DeleteOutlined,
    EditOutlined,
    PlusOutlined,
    DoubleRightOutlined,
    CalendarOutlined,
    ClockCircleOutlined,
    FileTextOutlined,
    TagOutlined
} from "@ant-design/icons";
import {
    Delete_ObjectOutOfService_Api,
    GetAll_ObjectOutOfService_Api,
    GetByObjectInstance_ObjectOutOfService_Api
} from "../../API/ObjectOutOfServiceApi";
import "../../assets/css/AllObjectOutOfServiceComponent.css";  // ← این خط را اضافه کنید
const { Title, Text } = Typography;

export const AllObjectOutOfServiceComponent = ({
    objectInstanceId,
    objectTitle,
    setLoading,
    showMessage,
    onAddClick,
    onEditClick,
    onBackClick
}) => {
    const [rows, setRows] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);

    useEffect(() => {
        loadData();
    }, [objectInstanceId]);

    const loadData = async () => {
        setLoadingTable(true);
        setLoading(true);

        try {
            const data = await GetByObjectInstance_ObjectOutOfService_Api(objectInstanceId);
            setLoading(false);
            setLoadingTable(false);

            if (data.messageStatus === "Successful") {
                setRows(data.messageData.data || []);
            } else {
                showMessage(data.message, "error");
                setRows([]);
            }
        } catch {
            setLoading(false);
            setLoadingTable(false);
            showMessage("خطا در ارتباط با سرور", "error");
            setRows([]);
        }
    };

    const deleteRow = async (id) => {
        setLoading(true);

        try {
            const data = await Delete_ObjectOutOfService_Api(id);
            setLoading(false);

            if (data.messageStatus === "Successful") {
                showMessage("رکورد با موفقیت حذف شد", "success");
                loadData();
            } else {
                showMessage(data.message, "error");
            }
        } catch {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error");
        }
    };

    // حذف چندتایی
    const handleBulkDelete = async () => {
        if (selectedRowKeys.length === 0) {
            showMessage("لطفاً حداقل یک رکورد را انتخاب کنید", "warning");
            return;
        }

        Modal.confirm({
            title: "حذف چندتایی",
            content: `آیا از حذف ${selectedRowKeys.length} رکورد انتخاب شده مطمئن هستید؟`,
            onOk: async () => {
                setLoading(true);
                try {
                    // فرض بر این است که API حذف چندتایی دارید
                    // اگر ندارید، به صورت حلقه حذف کنید
                    for (const id of selectedRowKeys) {
                        await Delete_ObjectOutOfService_Api(id);
                    }
                    showMessage(`${selectedRowKeys.length} رکورد با موفقیت حذف شد`, "success");
                    setSelectedRowKeys([]);
                    loadData();
                } catch {
                    showMessage("خطا در حذف رکوردها", "error");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    // ستون‌های جدول
    const columns = [
        {
            title: "ردیف",
            key: "index",
            width: 60,
            render: (_, __, index) => index + 1,
            align: "center"
        },
        {
            title: "تاریخ شروع",
            dataIndex: "fromDate_Shamsi",
            key: "fromDate_Shamsi",
            width: 130,
            render: (text) => (
                <Space>
                    <CalendarOutlined style={{ color: "#1890ff" }} />
                    <Text>{text || "-"}</Text>
                </Space>
            )
        },
        {
            title: "تاریخ پایان",
            dataIndex: "toDate_Shamsi",
            key: "toDate_Shamsi",
            width: 130,
            render: (text) => (
                <Space>
                    <ClockCircleOutlined style={{ color: "#faad14" }} />
                    <Text>{text || "-"}</Text>
                </Space>
            )
        },
        {
            title: "علت",
            dataIndex: "customTypeTitle",
            key: "customTypeTitle",
            width: 150,
            render: (text) => (
                <Tag color="blue" icon={<TagOutlined />}>
                    {text || "نامشخص"}
                </Tag>
            )
        },
        {
            title: "توضیحات",
            dataIndex: "description",
            key: "description",
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text || "بدون توضیحات"}>
                    <Space>
                        <FileTextOutlined style={{ color: "#52c41a" }} />
                        <Text ellipsis>{text || "-"}</Text>
                    </Space>
                </Tooltip>
            )
        },
        {
            title: "عملیات",
            key: "actions",
            width: 180,
            fixed: "right",
            render: (_, record) => (
                <Space size="small">
                    <Tooltip title="ویرایش">
                        <Button
                            type="primary"
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => onEditClick(record.id)}
                        >
                            ویرایش
                        </Button>
                    </Tooltip>

                    <Popconfirm
                        title="آیا از حذف این رکورد مطمئن هستید؟"
                        onConfirm={() => deleteRow(record.id)}
                        okText="بله، حذف شود"
                        cancelText="انصراف"
                        placement="left"
                    >
                        <Tooltip title="حذف">
                            <Button
                                danger
                                size="small"
                                icon={<DeleteOutlined />}
                            >
                                حذف
                            </Button>
                        </Tooltip>
                    </Popconfirm>
                </Space>
            )
        }
    ];

    // تنظیمات انتخاب ردیف
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
        selections: [
            Table.SELECTION_ALL,
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE
        ]
    };

    return (
        <div className="object-out-of-service-container">
            {/* هدر */}
            <Card
                style={{
                    marginBottom: 16,
                    borderRadius: 8,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                }}
                bodyStyle={{ padding: "16px 24px" }}
            >
                <Row align="middle" gutter={[16, 16]}>
                    <Col xs={24} sm={6} md={4}>
                        <Button
                            icon={<DoubleRightOutlined />}
                            onClick={onBackClick}
                            size="large"
                        >
                            بازگشت
                        </Button>
                    </Col>

                    <Col xs={24} sm={12} md={14} style={{ textAlign: "center" }}>
                        <div>
                            <Title level={3} style={{ margin: 0, color: "#1890ff" }}>
                                لیست تاریخهای خارج از سرویس
                            </Title>
                            {objectTitle && (
                                <Text type="secondary" style={{ fontSize: 14 }}>
                                    {objectTitle}
                                </Text>
                            )}
                        </div>
                    </Col>

                    <Col xs={24} sm={6} md={6} style={{ textAlign: "left" }}>
                        <Space wrap>
                            {selectedRowKeys.length > 0 && (
                                <Button
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={handleBulkDelete}
                                >
                                    حذف ({selectedRowKeys.length})
                                </Button>
                            )}
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={onAddClick}
                                size="large"
                            >
                                ثبت جدید
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Card>

            {/* جدول */}
            <Card
                style={{
                    borderRadius: 8,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                }}
            >
                <Table
                    columns={columns}
                    dataSource={rows}
                    rowKey="id"
                    rowSelection={rowSelection}
                    loading={loadingTable}
                    pagination={{
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) =>
                            `${range[0]}-${range[1]} از ${total} رکورد`,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50", "100"],
                        position: ["bottomCenter"],
                        locale: {
                            items_per_page: "/ صفحه",
                            jump_to: "برو به",
                            jump_to_confirm: "تأیید",
                            page: "صفحه",
                            prev_page: "صفحه قبل",
                            next_page: "صفحه بعد",
                            prev_5: "۵ صفحه قبل",
                            next_5: "۵ صفحه بعد",
                            prev_3: "۳ صفحه قبل",
                            next_3: "۳ صفحه بعد"
                        }
                    }}
                    scroll={{
                        x: 800,
                        y: window.innerHeight - 350
                    }}
                    locale={{
                        emptyText: (
                            <Empty
                                description="هیچ رکوردی یافت نشد"
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                            />
                        )
                    }}
                    bordered
                    size="middle"
                    sticky
                    className="custom-table"
                />
            </Card>

            {/* آمار */}
            {rows.length > 0 && (
                <Card
                    style={{
                        marginTop: 16,
                        borderRadius: 8,
                        background: "#f0f2f5"
                    }}
                    bodyStyle={{ padding: "12px 24px" }}
                >
                    <Row justify="space-between" align="middle">
                        <Col>
                            <Text strong>
                                تعداد کل: {rows.length} رکورد
                            </Text>
                        </Col>
                        {selectedRowKeys.length > 0 && (
                            <Col>
                                <Text type="warning" strong>
                                    {selectedRowKeys.length} رکورد انتخاب شده
                                </Text>
                            </Col>
                        )}
                    </Row>
                </Card>
            )}
        </div>
    );
};